export enum TaskCardSizes {
	small = "small",
	medium = "medium",
	large = "large",
}
